import React, { useCallback, useMemo } from 'react';

import FeedCard from 'components/FeedCard';
import { CircleArrow } from 'components/Icons/CircleArrow';
import WavetrakLink from 'components/WavetrakLink';
import { Post } from 'types/editorial';
import resizeImage from 'utils/resizeImage';

import styles from './PostsBlock.module.scss';

interface PostsBlockProps {
  name: string;
  posts: Post[] | [];
  slug: string;
  taxonomy: string;
  imageResizing: boolean;
}

const IMG_SETTINGS = 'w=740,q=85,f=auto,fit=contain';

const PostsBlock = ({ name, posts, slug, taxonomy, imageResizing }: PostsBlockProps) => {
  const category = useMemo(
    () => posts?.[0]?.categories?.filter((cat) => cat?.name === name)?.[0],
    [name, posts],
  );

  const postCards = useCallback(
    () =>
      posts.map((post) => {
        const timestamp = Math.floor(new Date(post.createdAt).getTime() / 1000);
        return (
          <FeedCard
            category={category}
            createdAt={timestamp}
            hideSubtitle
            imageUrl={resizeImage(post?.media?.feed2x || '', imageResizing, IMG_SETTINGS)}
            isPremium={post.premium}
            key={post.id}
            onClickLink={() => null}
            onClickTag={() => null}
            permalink={post.permalink}
            showTimestamp={!Number.isNaN(Number(timestamp))}
            subtitle=""
            title={post.title}
          />
        );
      }),
    [category, imageResizing, posts],
  );
  return (
    <div className={styles.postsBlock}>
      <h2>{name}</h2>
      <WavetrakLink href={`/${taxonomy}/${slug}`} className={styles.viewAll}>
        {`View All ${name}`}
      </WavetrakLink>
      <div className={styles.posts}>
        <div className={styles.cards}>
          {postCards()}
          <WavetrakLink href={`/${taxonomy}/${slug}`} className={styles.cardsViewAll}>
            <div className={styles.cardsViewAllArrow}>
              <CircleArrow />
              <br />
              View All
            </div>
          </WavetrakLink>
        </div>
      </div>
    </div>
  );
};

export default PostsBlock;
